import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function LoadingBar(props: any) {
  const classes = useStyles();
  return (
    <Grid container direction='column' className={classes.root}>
      <CircularProgress />
    </Grid>
  );
}

export default LoadingBar;
